<template>
  <v-btn
    v-if="showcustom"
    fab
    width="27"
    height="27"
    color="primary"
    elevation="0"
    class="btn_tippy vuetify--sacnite"
    :class="clase + (loading ? ' loading' : '')"
    :loading="loading"
    :title="title"
    @click="accion(computedParams)">
    <em :class="icon" />
  </v-btn>
</template>
<script>
export default {
  name: "ButtonCustom"
  , props: {
    paramobj: {
      default: null
      , type: Object
    }
    , paramarr: {
      default: null
      , type: Array
    }
    , paramstr: {
      default: null
      , type: String
    }
    , paramnum: {
      default: null
      , type: Number
    }
    , paramtype: {
      default: "Number"
      , type: String
    }
    , showcustom: {
      default: true
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , title: {
      default: null
      , type: String
    }
    , icon: {
      default: ""
      , type: String
    }
    , action: {
      default: ""
      , type: String
    }
    , clase: {
      default: null
      , type: String
    }
  }
  , computed: {
    computedParams() {
      switch (this.paramtype) {
      case "Number":
        return this.paramnum;
      case "String":
        return this.paramstr;
      case "Array":
        return this.paramarr;
      case "Object":
        return this.paramobj;
      }
      return null;
    }
  }
  , methods: {
    accion(params) {
      this.$emit(this.action, params);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/ButtonCustom.vue